import type { ReviewItem } from '@app/shared/types/sf-data'

export const getReviewItemKey = (
  item: Pick<ReviewItem, 'id' | 'itemClass'>
): string => `${item.itemClass}:${item.id}`
